import gMap from '@/plugins/GoogleMaps_V2/components/map'

const GoogleMapsPluginV2 = {
  install (Vue) {
    (function (options) {
      Vue.component('g-map', gMap)
    }({}))
  },
}

export default GoogleMapsPluginV2
